import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import { Modal, DeleteModal } from "../Modal";
import { CSVLink } from "react-csv";
import exportPDF from "../../utils/exportPDF";
import handleSearch from "../../utils/handleSearch";
import { fetchClubs, deleteClub } from "../../utils/queries/clubsQuery";
import NewClub from "./NewClub";
import { getStorage } from "../../utils/storage";
import { defineRole } from "../../utils/handleAccessRoles";

let copyData = [];

class Clubs extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selected_data: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });
    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  returnFilters() {
    const { page, limit } = this.state;
    const { clubId } = this.props;
    return {
      page,
      limit,
      id: clubId,
    };
  }

  getData = async (isLoading) => {
    try {
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await fetchClubs(
        defaultLanguage,
        this.returnFilters()
      );

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].name,
        key: "name",
        type: "link",
        onPress: (item) =>
          (window.location.href = `/dashboard/clubs/${item.name}/${item._id}`),
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].description,
        key: "description",
      },
      {
        title: language[this.props.defaultLanguage].active,
        key: "available",
      },
      {
        title: language[this.props.defaultLanguage].created_at,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteClub(
        this.props.defaultLanguage,
        this.state.selected_data._id
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  downloadExcel = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const { defaultLanguage } = this.props;

      const { data } = await fetchClubs(defaultLanguage, this.returnFilters());

      this.setState({
        isLoading: false,
        csvData: data,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  downloadPDF = async () => {
    this.setState({
      isLoading: true,
// eslint-disable-next-line no-unused-vars
    });

// eslint-disable-next-line no-unused-vars
    const { defaultLanguage, clubId } = this.props;

    const headers = this.returnTableHeaders();

    const { data } = await fetchClubs(defaultLanguage, this.returnFilters());

    this.setState({
      isLoading: false,
    });

    exportPDF(language[this.props.defaultLanguage].clubs, headers, data);
  };

  render() {
    const {
      add_club,
// eslint-disable-next-line no-unused-vars
      delete_club,
// eslint-disable-next-line no-unused-vars
      edit_club,
// eslint-disable-next-line no-unused-vars
      vital_sign,
// eslint-disable-next-line no-unused-vars
      export_,
      edit,
      delete_,
    } = language[this.props.defaultLanguage];

    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={(e) =>
            handleSearch(this, {
              copyData,
              value: e?.target?.value,
            })
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          showAdd={true}
          addButtonText={add_club}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].add
          )}
          rowPress={(item) =>
            this.handleShowModal("showModal", item.name, item)
          }
          // filters={[
          //   {
          //     type: "export",
          //     title: export_,
          //     button_type: "dropdown",
          //     icon: "bx bxs-download",
          //     options: [
          //       {
          //         name: "PDF",
          //         onPress: this.downloadPDF.bind(this),
          //       },
          //       {
          //         name: "CSV",
          //         onPress: this.downloadExcel.bind(this),
          //       },
          //     ],
          //   },
          // ]}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: "Club",
                operation: "update",
              }),
              name: edit,
              onPress: (item) =>
                this.handleShowModal("showModal", edit_club, item),
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: "Club",
                operation: "delete",
              }),
              name: delete_,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                delete_club
              ),
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewClub
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selected_data.name}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={"Intwali clubs 25" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Clubs);
